import Vue from 'vue';

Vue.filter('removeVat', function(value, vat) {
    if (!value) return 0;
    return value / ((100 + vat) / 100);
});
